import type { ReactElement } from 'react'
import {
  columnPickerList,
  columnPickerSection,
  columnPickerSectionTitle
} from './DataTable.css'
import DataTableColumnPickerRow, {
  type ColumnPickerZone,
  type DataTableColumnPickerItem,
  type DataTableColumnPin
} from './DataTableColumnPickerRow'

type DataTableColumnPickerZoneSectionProps = {
  title: string
  zone: ColumnPickerZone
  items: DataTableColumnPickerItem[]
  dragDisabled: boolean
  onToggle: (columnId: string) => void
  onPinChange: (columnId: string, pin: DataTableColumnPin) => void
}

const DataTableColumnPickerZoneSection = ({
  title,
  zone,
  items,
  dragDisabled,
  onToggle,
  onPinChange
}: DataTableColumnPickerZoneSectionProps): ReactElement | null => {
  if (items.length === 0) return null

  return (
    <div className={columnPickerSection}>
      <div className={columnPickerSectionTitle}>{title}</div>
      <div className={columnPickerList}>
        {items.map((column) => (
          <DataTableColumnPickerRow
            key={column.id}
            column={column}
            zone={zone}
            dragDisabled={dragDisabled}
            onToggle={onToggle}
            onPinChange={onPinChange}
          />
        ))}
      </div>
    </div>
  )
}

export default DataTableColumnPickerZoneSection
